import React, { useEffect } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import markerIcon from './assets/images/Marker.png';
import Logo from './assets/images/Logo/Hazar-terra-leaf.png'

const LocationMap = () => {
  useEffect(() => {
    // Initialiser la carte
    const map = L.map('map').setView([33.5930227, -7.6038219], 17);

    // Ajouter des tuiles CartoDB Positron
    L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
      subdomains: 'abcd',
      maxZoom: 19,
    }).addTo(map);

    // Créer un icône personnalisé
    const customIcon = L.icon({
      iconUrl: markerIcon,
      iconSize: [25, 40],
      iconAnchor: [20, 40],
      popupAnchor: [0, -40],
    });

    // Ajouter un marqueur
    L.marker([33.5930227, -7.6038219], { icon: customIcon })
      .addTo(map)
      .bindPopup(`
        <div style="text-align: center;">
          <img src="${Logo}" alt="Logo" style="width: 300px; height: auto;" />
        </div>
      `)
      .openPopup();

    // Nettoyage : détruire la carte si le composant est démonté
    return () => map.remove();
  }, []);

  return (
    <div
      id="map"
      style={{
        width: '100%',
        height: '500px',
        border: '1px solid #ccc',
      }}
    ></div>
  );
};

export default LocationMap;